module.exports = __webpack_public_path__ + "img/orange-circle.be0cf52b.svg";